import { render, staticRenderFns } from "./ConcernedForm.vue?vue&type=template&id=4347f6bc&scoped=true&"
import script from "./ConcernedForm.vue?vue&type=script&lang=js&"
export * from "./ConcernedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4347f6bc",
  null
  
)

export default component.exports